/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import { Button, Col, Form, Input, Modal, Row, Select, message } from 'antd';
import { hanhtrangsoClient } from 'configs/api';
import { IS_SACHSO } from 'constants/settings';
import { generateSHA1 } from 'helpers/CryptoHelper';
import { sendEmailV2 } from 'helpers/MailHelper';
import { query } from 'helpers/QueryHelper';
import { checkExistsEmail } from 'modules/Administration/components/Users/api/user_api';
import { getNameSplit } from 'modules/Auth/components/UserProfile/components/UpdateProfile';
import React, { useEffect, useState } from 'react';

const { Option } = Select;

export default ({ isOpen, onCloseRegisterModal, onRefeshData, record }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen === 'update' && record) {
      const { firstName, lastName } = getNameSplit(record.fullName);
      form.setFieldsValue({
        firstname: firstName,
        lastname: lastName,
        email: record.email,
        schoolTypeId: record.schoolTypeId,
        userType: record.roleID,
      });
    } else {
      form.resetFields();
    }
  }, [isOpen, record]);

  const registerUser_hanhtrangso = (values) => {
    const body = {
      ...values,
      gender: 1,
      parentFullname: '',
      birthday: '1990-1-1',
    };
    hanhtrangsoClient.post('/Register', body);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const { lastname, firstname, email, password, schoolTypeId, userType } = values;
    if (isOpen === 'update') {
      const params = { userId: record?.id, email, fullName: lastname.concat(' ', firstname), roleId: userType, schoolTypeId };
      await query('p_SACHSO_USERS_Update', params)
        .then((response) => {
          message.success('Cập nhật tài khoản thành công!');
          onCloseRegisterModal?.();
          onRefeshData?.();
        })
        .catch((err) => {
          message.error('Cập nhật tài khoản thất bại!');
        });
      setLoading(false);
      return;
    }
    await checkExistsEmail(email)
      .then((res) => {
        // Email đã tồn tại
        message.warning('Email đã được đăng kí trước đó!');
      })
      .catch(async (err) => {
        // Em chưa đăng kí
        if (IS_SACHSO) {
          // Nếu là live thì mới gọi API đăng kí hanhtrangso
          registerUser_hanhtrangso(values);
        }
        const params = { email, password: generateSHA1(password), fullName: lastname.concat(' ', firstname), roleId: userType, schoolTypeId, cityId: 0, phone: '' };
        await query('p_SACHSO_Users_Register', params)
          .then((response) => {
            message.success('Tạo tài khoản thành công!');

            if (userType === 1) {
              if (schoolTypeId === 1) {
                // Tiểu học
                sendEmailV2(email, password, 'SachSo_SendEmailCapTH');
              } else if (schoolTypeId === 2) {
                // THCS
                sendEmailV2(email, password, 'SachSo_SendEmailCapTHCS');
              } else if (schoolTypeId === 3) {
                // THPT
              }
            } else if (userType === 2) sendEmailV2(email, password, 'SACHSO_SendEmail_RegisterAccount'); // gởi email cho giáo viên
            // sendEmailV2(email, '', 'SACHSO_SendEmail_ExistsAccount'); //gởi email cho giáo viên khi tài khoản đã tồn tại

            onCloseRegisterModal?.();
            onRefeshData?.();
          })
          .catch((err) => {
            message.error('Tạo tài khoản thất bại!');
          });
      });
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Modal
        open={!!isOpen}
        title={isOpen === 'insert' ? 'THÊM NGƯỜI DÙNG' : 'CẬP NHẬT NGƯỜI DÙNG'}
        onCancel={() => onCloseRegisterModal?.()}
        footer={
          <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'end', columnGap: 10 }}>
            <Button
              onClick={() => {
                onCloseRegisterModal?.();
              }}
            >
              Đóng
            </Button>
            <Button loading={loading} onClick={() => form.submit()} type='primary'>
              {isOpen === 'update' ? 'Cập nhật' : 'Đăng ký tài khoản'}
            </Button>
          </div>
        }
        centered
        width={520}
      >
        <Form layout='vertical' autoComplete='off' form={form} onFinish={onFinish} requiredMark={false} initialValues={{ schoolTypeId: 1, userType: 1 }}>
          <Row gutter={[12, 12]}>
            <Col sm={16} xs={24}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label='Họ và tên đệm'
                name='lastname'
                hasFeedback
                rules={[
                  { whitespace: true, message: 'Chưa nhập họ và tên đệm' },
                  { required: true, message: 'Chưa nhập họ và tên đệm' },
                ]}
              >
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col sm={8} xs={24}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label='Tên'
                name='firstname'
                hasFeedback
                rules={[
                  { whitespace: true, message: 'Chưa nhập tên' },
                  { required: true, message: 'Chưa nhập tên' },
                ]}
              >
                <Input allowClear />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            style={{ fontWeight: 600 }}
            label='Email (Dùng để đăng nhập)'
            name='email'
            hasFeedback
            rules={[
              { type: 'email', message: 'Email không hợp lệ' },
              { whitespace: true, message: 'Chưa nhập Email' },
              { required: true, message: 'Chưa nhập Email' },
            ]}
          >
            <Input allowClear disabled={isOpen === 'update'} />
          </Form.Item>
          {isOpen === 'insert' && (
            <Row gutter={[12, 12]}>
              <Col sm={12} xs={24}>
                <Form.Item
                  style={{ fontWeight: 600 }}
                  label='Mật khẩu'
                  name='password'
                  hasFeedback
                  rules={[
                    { whitespace: true, message: 'Chưa nhập mật khẩu' },
                    { required: true, message: 'Chưa nhập mật khẩu' },
                    { min: 6, message: 'Mật khẩu ít nhất có 6 ký tự' },
                  ]}
                >
                  <Input.Password allowClear />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24}>
                <Form.Item
                  style={{ fontWeight: 600 }}
                  label='Xác nhận mật khẩu'
                  name='confirmPassword'
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    { whitespace: true, message: 'Chưa nhập xác nhận mật khẩu' },
                    { required: true, message: 'Chưa nhập xác nhận mật khẩu' },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Xác nhận mật khẩu không khớp'));
                      },
                    }),
                  ]}
                >
                  <Input.Password allowClear />
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={[12, 12]}>
            <Col sm={12} xs={24}>
              <Form.Item name='schoolTypeId' label='Cấp' rules={[{ required: true }]}>
                <Select
                  getPopupContainer={(triggerNode) => {
                    return triggerNode.parentNode;
                  }}
                >
                  <Option value={0}>Mầm non</Option>
                  <Option value={1}>Cấp 1</Option>
                  <Option value={2}>Cấp 2</Option>
                  <Option value={3}>Cấp 3</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item name='userType' label='Loại tài khoản' rules={[{ required: true }]}>
                <Select
                  getPopupContainer={(triggerNode) => {
                    return triggerNode.parentNode;
                  }}
                >
                  <Option value={1}>Học sinh</Option>
                  <Option value={2}>Giáo viên</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </React.Fragment>
  );
};
